import { i } from '../lit-element.js';

const forms = i`
  .grv-form-field {
    position: relative;
    text-align: left;
  }
`;

export { forms };
